module.exports = __webpack_public_path__ + "static/media/no-risk-comorbidity.962a6e5b.svg";